import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-subtitle1 q-px-md q-py-md"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "brand-app-bg brand-border border-bottom text-overline text-weight-bold text-uppercase text-dark q-px-md q-py-md" }
const _hoisted_6 = { class: "q-pt-md" }
const _hoisted_7 = { class: "q-pt-md q-px-md" }
const _hoisted_8 = { class: "q-pt-md q-px-md q-pb-md" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6 q-pr-sm" }
const _hoisted_11 = { class: "col-6 q-pl-sm" }
const _hoisted_12 = {
  key: 0,
  class: "flex items-center full-width justify-between q-pb-md q-px-md"
}
const _hoisted_13 = { key: 3 }

import { onMounted, ref, computed } from "vue";
  import { QSelect } from "quasar";

  import { useDialog } from "src/functions";
  import { LoanApplication, ResidentialAddress } from "src/types/loan-application/index";
  import { ResidentialStatus_Enum } from "src/types/enums/index";

  import DataTable from "./DataTable.vue";
  import AddressLookup from "../lookups/AddressLookup.vue";
  import ResidentialStatusSelect from "src/components/form/inputs/ResidentialStatusSelect.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AddressDetailsForm',
  props: {
    proposal: {
      type: Object,
      default: () => ({} as LoanApplication)
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, { expose: __expose }) {

  const props = __props;

  onMounted(() => {
    if (!props.proposal.customer.residentialAddressHistory || props.proposal.customer.residentialAddressHistory.length === 0) {
      props.proposal.customer.residentialAddressHistory = [{ isCurrent: true } as ResidentialAddress];
    }
  });

  function addressSelected(val: ResidentialAddress, index: number) {
    props.proposal.customer.residentialAddressHistory[index] = val;

    props.proposal.customer.residentialAddressHistory[index].isCurrent = index === 0 ? true : false;

  }

  function addAddress() {
    if (!isValid()) {
      useDialog("Information", "Please complete existing addresses before adding a new one");
      return;
    }
    props.proposal.customer.residentialAddressHistory.push({} as ResidentialAddress);
  }

  const addressLength = computed(() => {
    if (!props.proposal.customer.residentialAddressHistory) {
      return 0;
    }
    let count = 0;
    props.proposal.customer.residentialAddressHistory.forEach(a => {
      count += a.yearsAtAddress ? a.yearsAtAddress * 12 : 0;
      count += a.monthsAtAddress ? a.monthsAtAddress : 0;
    });
    return count;
  });

  const addressRefs = ref<CustomForm[]>([]);
  const statusRefs = ref<QSelect[]>([]);
  const yearRefs = ref<QSelect[]>([]);
  const monthRefs = ref<QSelect[]>([]);

  function isValid() {
    let valid = true;
    for (let i = 0; i < statusRefs.value.length; i++) {
      addressRefs.value[i]?.validate() ? null : valid = false;
      statusRefs.value[i]?.validate() ? null : valid = false;
      yearRefs.value[i]?.validate() ? null : valid = false;
      monthRefs.value[i]?.validate() ? null : valid = false;
    }
    return valid;
  }

  __expose({ validate });
  function validate() {
    return isValid() && addressLength.value >= 36 ? true : false;
  }

  const dataTableData = computed(() => {
    const d = [
      {
        label: "Current Address", value: `
      <span>${props.proposal.customer.residentialAddressHistory[0]?.subBuilding ? props.proposal.customer.residentialAddressHistory[0]?.subBuilding + ", " : ""}${props.proposal.customer.residentialAddressHistory[0]?.buildingName ? props.proposal.customer.residentialAddressHistory[0]?.buildingName : ""} </span>
      <div>${props.proposal.customer.residentialAddressHistory[0]?.buildingNumber} ${props.proposal.customer.residentialAddressHistory[0]?.street}</div>
      <div>${props.proposal.customer.residentialAddressHistory[0]?.town}</div>
      <div>${props.proposal.customer.residentialAddressHistory[0]?.postcode}</div>
      <div class="q-pt-md">${props.proposal.customer.residentialAddressHistory[0]?.yearsAtAddress} years ${props.proposal.customer.residentialAddressHistory[0]?.monthsAtAddress} months</div>
      <div>${ResidentialStatus_Enum[props.proposal.customer.residentialAddressHistory[0]?.residentialStatusType]}</div>
      `, html: true
      }
    ];
    if (props.proposal.customer.residentialAddressHistory.length > 1) {
      for (let i = 1; i < props.proposal.customer.residentialAddressHistory.length; i++) {
        d.push({
          label: "Previous Address " + i, value: `
      <span>${props.proposal.customer.residentialAddressHistory[i]?.subBuilding ? props.proposal.customer.residentialAddressHistory[i]?.subBuilding + ", " : ""}${props.proposal.customer.residentialAddressHistory[i]?.buildingName ? props.proposal.customer.residentialAddressHistory[i]?.buildingName : ""} </span>
      <div>${props.proposal.customer.residentialAddressHistory[i]?.buildingNumber} ${props.proposal.customer.residentialAddressHistory[i]?.street}</div>
      <div>${props.proposal.customer.residentialAddressHistory[i]?.town}</div>
      <div>${props.proposal.customer.residentialAddressHistory[i]?.postcode}</div>
      <div class="q-pt-md">${props.proposal.customer.residentialAddressHistory[i]?.yearsAtAddress} years ${props.proposal.customer.residentialAddressHistory[i]?.monthsAtAddress} months</div>
      <div>${ResidentialStatus_Enum[props.proposal.customer.residentialAddressHistory[i]?.residentialStatusType]}</div>
      `, html: true
        });
      }
    }

    return d;
  });

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Address History "))
      : _createCommentVNode("", true),
    (__props.showTitle)
      ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.proposal.customer.residentialAddressHistory, (address, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'address-' + index
            }, [
              (index === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "brand-app-bg brand-border border-bottom text-overline text-weight-bold text-uppercase text-dark q-px-md q-py-md" }, "Current Address", -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, "Previous Address " + _toDisplayString(index), 1)
                  ])),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(AddressLookup, {
                  ref_for: true,
                  ref_key: "addressRefs",
                  ref: addressRefs,
                  onAddressSelected: ($val) => addressSelected($val, index)
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "q-pb-xs text-overline text-uppercase text-dark text-weight-bold" }, "Search for address", -1)
                  ])),
                  _: 2,
                  __: [1]
                }, 1032, ["onAddressSelected"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(ResidentialStatusSelect, {
                  modelValue: address.residentialStatusType,
                  "onUpdate:modelValue": ($event: any) => ((address.residentialStatusType) = $event),
                  ref_for: true,
                  ref_key: "statusRefs",
                  ref: statusRefs,
                  rules: [val => !!val || 'Required']
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "q-pb-xs text-overline text-weight-bold text-uppercase text-dark" }, "Residential Status *", -1)
                  ])),
                  _: 2,
                  __: [2]
                }, 1032, ["modelValue", "onUpdate:modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "q-pb-xs text-overline text-weight-bold text-uppercase text-dark" }, "Time at address *", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(QSelect), {
                      modelValue: address.yearsAtAddress,
                      "onUpdate:modelValue": ($event: any) => ((address.yearsAtAddress) = $event),
                      options: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
                      ref_for: true,
                      ref_key: "yearRefs",
                      ref: yearRefs,
                      rules: [(val) => (val || (address.monthsAtAddress && address.monthsAtAddress > 0)) || 'Required'],
                      label: "Years",
                      "popup-content-class": "limit-dd-height",
                      outlined: "",
                      dense: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(QSelect), {
                      modelValue: address.monthsAtAddress,
                      "onUpdate:modelValue": ($event: any) => ((address.monthsAtAddress) = $event),
                      options: [0,1,2,3,4,5,6,7,8,9,10,11],
                      ref_for: true,
                      ref_key: "monthRefs",
                      ref: monthRefs,
                      rules: [(val) => (val || (address.yearsAtAddress && address.yearsAtAddress > 0)) || 'Required'],
                      label: "Months",
                      "popup-content-class": "limit-dd-height",
                      outlined: "",
                      dense: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                  ])
                ])
              ])
            ]))
          }), 128)),
          (addressLength.value > 0 && addressLength.value < 36)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "q-field--error text-negative" }, "At least 3 years address history required", -1)),
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  color: "primary",
                  label: "Add Address",
                  onClick: addAddress
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(DataTable, { data: dataTableData.value }, null, 8, ["data"])
        ]))
  ], 64))
}
}

})